/**
 * 使用常量替代 Mutation 事件类型
 */

// 设置收起状态
export const SET_COLLAPSED = 'SET_COLLAPSED'
// 企业基本信息-企业编码
export const SET_CODE = 'SET_CODE'
// 企业ID
export const SET_CLIENTID = 'SET_CLIENTID'
// 企业详情
export const SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO'
// 客户信息
export const SET_CUSTOMER_DETAIL = 'SET_CUSTOMER_DETAIL'
// 客户编码
export const SET_COMPANY = 'SET_COMPANY'
// 邓白氏报告
export const SET_BUREAU = 'SET_BUREAU'
// 客户权限
export const SET_PERMISSIONS = 'SET_PERMISSIONS'
// logo
export const SET_LOGO_URL = 'SET_LOGO_URL'
// 系统名称
export const SET_SYS_NAME = 'SET_SYS_NAME'
